import React, { useState } from "react"
import { Link } from "gatsby"
import Payhere from "payhere-embed-sdk/dist/react"

import { routes } from "../utils/routes"
import Layout from "../components/Layout"
import SEO from "../components/SEO"
import { StaticImage } from "gatsby-plugin-image"

type PageProps = {
  data: any
}

const DonateNow: React.FC<PageProps> = ({ data }) => {
  const [showPayhere, setShowPayhere] = useState<string | null>(null)

  return (
    <Layout
      sectionOne={
        <>
          <div className="relative h-[67vh] md:min-h-[75vh]">
            <StaticImage
              src="../../static/images/_F7A7042.jpg"
              className="absolute inset-0 w-full h-full object-cover -z-50"
              alt="Donate Header"
            />
            <div className="absolute inset-0 bg-[#131312]/50 -z-40"></div>

            <div className="container text-white h-[67vh] md:min-h-[75vh] flex items-center px-4">
              <div className="pl-2 md:pl-6 lg:pl-10 max-w-[1000px] translate-y-10 md:translate-y-16 lg:translate-y-20">
                <div className="pb-4">
                  <h1
                    className="text-left text-white text-[300%] sm:text-[400%] md:text-[531.25%] leading-[1] font-bold normal-case tracking-normal font-gilroy"
                  >
                    Donate Now
                  </h1>
                  <div className="mt-5 h-[8px] sm:h-[10px] w-[200px] sm:w-[320px] bg-primary"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Gold donation options bar below the fold */}
          <div className="bg-primary w-full h-[33vh] md:h-auto md:block">
            <div className="flex flex-col h-full w-full md:grid md:grid-cols-2 md:gap-0 md:items-stretch md:min-h-[84px]">
              <button
                className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2"
                onClick={() => setShowPayhere(
                  "https://app.payhere.co/rbai-foundation/regular-donation"
                )}
              >
                Setup a Regular Gift
              </button>
              <button
                className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] text-[19px] leading-[32.3px] md:px-2"
                onClick={() => setShowPayhere(
                  "https://app.payhere.co/rbai-donations/donation-one-off"
                )}
              >
                Give One Off Gift
              </button>
            </div>
          </div>
        </>
      }
    >
      <SEO title="Donate Now" />
      <div className="container py-2 sm:py-5 px-4">
        <div className="grid gap-8 md:grid-cols-2 pb-14">
          {/*
            <Link className="button d-block my-3" to={routes.pledge()}>
              Sponsor A Personalised Paviour
            </Link>
          */}
        </div>
        <div className="flex justify-center">
          <div className="flex flex-col gap-4 max-w-[700px]">
            <p className="font-gilroy-light">Other ways you can donate to RBAI:</p>
            <p className="font-gilroy-light">
              <strong className="font-gilroy font-bold">By Post</strong> – you can send a one-off gift or set up a
              regular gift by downloading a <a
                className="link underline hover:no-underline font-gilroy-light"
                href="/docs/Donation Form MAY26.pdf"
                target="_blank"
              >
                donation form here
              </a>{" "}
              and returning to the address below. For one-off gifts, all cheques
              should be payable to  'The RBAI Foundation.
            </p>
            <p className="font-gilroy-light">
              <strong className="font-gilroy font-bold">Legacies</strong> – find out more information about
              leaving a legacy gift{" "}
              <Link
                className="link underline hover:no-underline font-gilroy-light"
                to={routes.legacies()}
              >
                here.
              </Link>
            </p>
            <p className="font-gilroy-light">
              <strong className="font-gilroy font-bold">Overseas Donors</strong> – whether a cash gift or shares,
              in first instance please contact Peter Anderson, RBAI Foundation
              Director and we will provide the appropriate paperwork and ensure
              you can give in the most tax efficient manner.
            </p>
            <p className="font-gilroy-light">
              <strong className="font-gilroy font-bold">Donate Stocks & Shares</strong> – this offers the most
              generous tax relief available to donors, combining relief on
              income and capital gains tax. Share gifts qualify for tax relief
              equal to the market value of the shares on the day the gift is
              made, including associated costs such as broker fees. In the first
              instance, please contact Peter Anderson, RBAI Foundation Director
              for more information.
            </p>
            <p className="font-gilroy-light">
              <strong className="font-gilroy font-bold">Donate an Insurance Policy –</strong> contribute an
              existing life insurance policy, or designate the School as the
              owner and beneficiary of a new policy. In either case, the value
              of the existing policy (or the amount of the donors investment, if
              less) or the donated annual premium payments are deductible from
              your tax liabilities as charitable contributions. In first
              instance please contact Peter Anderson, RBAI Foundation Director.
            </p>
            <p className="font-gilroy-light">
              <strong className="font-gilroy font-bold">Gifts In Kind</strong> – this includes donations of goods
              and services rather than monetary donations. Whether a camera for
              the art department or property, antiques, art or professional
              services offered to the School free of charge, please contact
              Peter Anderson, RBAI Foundation Director in first instance.
            </p>
            <p className="font-gilroy-light">
              As with donated shares, gifts in kind may be sold on by the School
              to help achieve our fundraising goals.
            </p>
            <p className="font-gilroy-light">
              For any enquiries, please contact:
              <br />
              Peter Anderson, RBAI Foundation Director
              <br />
              Email:{" "}
              <a
                className="link underline hover:no-underline font-gilroy-light"
                href="mailto:p.anderson@rbai.org.uk"
              >
                p.anderson@rbai.org.uk
              </a>
              <br />
              Tel: +44 (0) 28 9024 0461
            </p>
            <p className="font-gilroy-light">
              Please send all correspondence to:
              <br />
              The RBAI Foundation
              <br />
              The Royal Belfast Academical Institution
              <br />
              College Square East
              <br />
              Belfast
              <br />
              BT1 6DL
            </p>
          </div>
        </div>
      </div>

      {/* Payhere Modal Container */}
      <div id="payhere-modal" className={`fixed inset-0 z-50 ${showPayhere ? 'block' : 'hidden'}`}>
        <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" aria-hidden="true"></div>
          <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
            <div className="payhere-embed-container"></div>
          </div>
        </div>
      </div>

      <Payhere
        selector="#payhere-modal"
        embedURL={showPayhere}
        open={showPayhere !== null}
        onClose={() => {
          setShowPayhere(null)
        }}
        onSuccess={() => {
          console.log('Payment successful!')
          setShowPayhere(null)
        }}
        onFailure={() => {
          console.log('Payment failed!')
          setShowPayhere(null)
        }}
      />
    </Layout>
  )
}

export default DonateNow
